export const sections = {
    home: [
        {
            id: "content-frontpage-breaking-news",
            name: "أخبار عاجلة",
        },
        {
            id: "content-frontpage-latest-news",
            name: "أحدث الأخبار",
        },
        {
            id: "content-frontpage-latest-media",
            name: "أحدث الوسائط",
        },
        {
            id: "content-frontpage-highlights",
            name: "يسلط الضوء",
        },
        {
            id: "content-frontpage-top-stories",
            name: "أهم الأخبار",
        },
        {
            id: "content-frontpage-international",
            name: "دولي",
        },
        {
            id: "content-frontpage-featured",
            name: "متميز",
        },
        {
            id: "content-frontpage-underscored",
            name: "يؤكد",
        },
        {
            id: "content-frontpage-happening-now",
            name: "يحدث الآن",
        },
        {
            id: "content-frontpage-hot-topics",
            name: "مواضيع مثيرة",
        },
        {
            id: "content-frontpage-paid-content",
            name: "المحتوى المدفوع",
        },
    ],
    us: [
        {
            id: "content-us-world-news",
            name: "اخبار العالم",
        },
        {
            id: "content-us-around-the-nation",
            name: "في جميع أنحاء البلاد",
        },
        {
            id: "content-us-roundup",
            name: "جمع الشمل",
        },
        {
            id: "content-us-crime+justice",
            name: "الجريمة والعدالة",
        },
        {
            id: "content-us-around-the-us",
            name: "حول الولايات المتحدة",
        },
        {
            id: "content-us-latest-media",
            name: "أحدث الوسائط",
        },
        {
            id: "content-us-business",
            name: "عمل",
        },
        {
            id: "content-us-underscored",
            name: "يؤكد",
        },
        {
            id: "content-us-state-by-state",
            name: "الدولة حسب الدولة",
        },
        {
            id: "content-us-hot-topics",
            name: "مواضيع مثيرة",
        },
        {
            id: "content-us-paid-content",
            name: "المحتوى المدفوع",
        },
    ],
    world: [
        {
            id: "content-world-global-trends",
            name: "الاتجاهات العالمية",
        },
        {
            id: "content-world-around-the-world",
            name: "حول العالم",
        },
        {
            id: "content-world-latest-media",
            name: "أحدث الوسائط",
        },
        {
            id: "content-world-today",
            name: "اليوم",
        },
        {
            id: "content-world-featured",
            name: "متميز",
        },
        {
            id: "content-world-international",
            name: "دولي",
        },
        {
            id: "content-world-global-impact",
            name: "التأثير العالمي",
        },
        {
            id: "content-world-underscored",
            name: "يؤكد",
        },
        {
            id: "content-world-global-issues",
            name: "قضايا عالمية",
        },
        {
            id: "content-world-hot-topics",
            name: "مواضيع مثيرة",
        },
        {
            id: "content-world-paid-content",
            name: "المحتوى المدفوع",
        },
    ],
    politics: [
        {
            id: "content-politics-what-really-matters",
            name: "ماهي المشكلة الحقيقية",
        },
        {
            id: "content-politics-today",
            name: "اليوم",
        },
        {
            id: "content-politics-latest-headlines",
            name: "العناوين الرئيسية",
        },
        {
            id: "content-politics-latest-media",
            name: "أحدث الوسائط",
        },
        {
            id: "content-politics-election",
            name: "انتخاب",
        },
        {
            id: "content-politics-more-political-news",
            name: "المزيد من الأخبار السياسية",
        },
        {
            id: "content-politics-underscored",
            name: "يؤكد",
        },
        {
            id: "content-politics-trending",
            name: "الشائع",
        },
        {
            id: "content-politics-around-the-world",
            name: "حول العالم",
        },
        {
            id: "content-politics-hot-topics",
            name: "مواضيع مثيرة",
        },
        {
            id: "content-politics-paid-content",
            name: "المحتوى المدفوع",
        },
    ],
    business: [
        {
            id: "content-business-latest-trends",
            name: "آخر الصيحات",
        },
        {
            id: "content-business-market-watch",
            name: "مراقبة السوق",
        },
        {
            id: "content-business-economy-today",
            name: "الاقتصاد اليوم",
        },
        {
            id: "content-business-must-read",
            name: "يجب أن يقرأ",
        },
        {
            id: "content-business-educational",
            name: "تعليمية",
        },
        {
            id: "content-business-underscored",
            name: "يؤكد",
        },
        {
            id: "content-business-investing-101",
            name: "استثمار 101",
        },
        {
            id: "content-business-stock-market",
            name: "سوق الأوراق المالية",
        },
        {
            id: "content-business-impact",
            name: "تأثير",
        },
        {
            id: "content-business-hot-topics",
            name: "مواضيع مثيرة",
        },
        {
            id: "content-business-paid-content",
            name: "المحتوى المدفوع",
        },
    ],
    opinion: [
        {
            id: "content-opinion-a-deeper-look",
            name: "نظرة أعمق",
        },
        {
            id: "content-opinion-top-issues",
            name: "أعلى القضايا",
        },
        {
            id: "content-opinon-trending",
            name: "الشائع",
        },
        {
            id: "content-opinion-think-about-it",
            name: "فكر في الأمر",
        },
        {
            id: "content-opinion-latest-media",
            name: "أحدث الوسائط",
        },
        {
            id: "content-opinion-in-case-you-missed-it",
            name: "في حال فوته على نفسك",
        },
        {
            id: "content-opinion-environmental-issues",
            name: "القضايا البيئية",
        },
        {
            id: "content-opinion-underscored",
            name: "يؤكد",
        },
        {
            id: "content-opinon-what-matters-most",
            name: "أكثر مايهم",
        },
        {
            id: "content-opinion-hot-topics",
            name: "مواضيع مثيرة",
        },
        {
            id: "content-opinion-paid-content",
            name: "المحتوى المدفوع",
        },
    ],
    health: [
        {
            id: "content-health-trending",
            name: "الشائع",
        },
        {
            id: "content-health-latest-facts",
            name: "أحدث الحقائق",
        },
        {
            id: "content-health-medical-breakthroughs",
            name: "الاختراقات الطبية",
        },
        {
            id: "content-health-latest-videos",
            name: "أحدث مقاطع الفيديو",
        },
        {
            id: "content-health-educational",
            name: "تعليمية",
        },
        {
            id: "content-health-fitness",
            name: "لياقة بدنية",
        },
        {
            id: "content-health-guides",
            name: "خطوط إرشاد",
        },
        {
            id: "content-health-underscored",
            name: "يؤكد",
        },
        {
            id: "content-health-what-to-eat",
            name: "ما الذي تريد أن تأكله",
        },
        {
            id: "content-health-hot-topics",
            name: "مواضيع مثيرة",
        },
        {
            id: "content-health-paid-content",
            name: "المحتوى المدفوع",
        },
    ],
};
